import { render } from "./CustomerRegisterPage.vue?vue&type=template&id=e8ee75c4&scoped=true"
import script from "./CustomerRegisterPage.vue?vue&type=script&lang=js"
export * from "./CustomerRegisterPage.vue?vue&type=script&lang=js"

import "./CustomerRegisterPage.vue?vue&type=style&index=0&id=e8ee75c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ee75c4"]])

export default __exports__